"use client";

import { Great_Vibes, Cormorant_Garamond } from "next/font/google";
import { GoldDivider } from "@/app/components/WeddingDecor";
import SessionBackLink from "@/app/components/SessionBackLink";

const greatVibes = Great_Vibes({
  subsets: ["latin"],
  weight: "400",
});

const cormorant = Cormorant_Garamond({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
});

export default function AfterPartyPage() {
  return (
    <main className={`min-h-screen bg-[#f6f4ef] px-4 py-6 text-slate-800 sm:px-6 lg:px-8 ${cormorant.className}`}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex items-center justify-between gap-4">
          <SessionBackLink />

          <h1 className={`${greatVibes.className} wedding-gold-halo text-5xl text-[#1f4e79] sm:text-6xl`}>
            After Party
          </h1>

          <div className="w-20" />
        </div>

        <section className="overflow-hidden rounded-[2rem] border border-[#decf9b] bg-[linear-gradient(180deg,#fffdfa_0%,#f5eee0_100%)] shadow-[0_24px_60px_rgba(31,78,121,0.10)]">
          <div className="px-6 py-10 sm:px-10 sm:py-12">
            <p className="text-center text-[11px] uppercase tracking-[.28em] text-[#8c8c86]">
              Keep The Celebration Going
            </p>

            <h2 className={`${greatVibes.className} wedding-gold-halo mt-5 text-center text-5xl text-[#1f4e79] sm:text-6xl`}>
              Join us after the wedding
            </h2>

            <div className="mt-5">
              <GoldDivider />
            </div>

            <div className="mt-8 grid gap-5 md:grid-cols-3">
              <div className="rounded-[1.75rem] border border-[#e4d19b] bg-white/90 px-6 py-7 text-center shadow-sm">
                <p className="text-xs uppercase tracking-[.2em] text-[#8c8c86]">Venue</p>
                <p className="mt-3 text-3xl font-semibold text-[#1f3f6d]">
                  Tovil Working Mens Club
                </p>
              </div>

              <div className="rounded-[1.75rem] border border-[#e4d19b] bg-white/90 px-6 py-7 text-center shadow-sm">
                <p className="text-xs uppercase tracking-[.2em] text-[#8c8c86]">Address</p>
                <p className="mt-3 text-2xl font-semibold leading-10 text-[#1f3f6d]">
                  Tovil Hill
                  <br />
                  Maidstone
                  <br />
                  ME15 6QS
                </p>
              </div>

              <div className="rounded-[1.75rem] border border-[#e4d19b] bg-[linear-gradient(180deg,#1f4e79_0%,#173d61_100%)] px-6 py-7 text-center shadow-sm">
                <p className="text-xs uppercase tracking-[.2em] text-[#d9c27c]">Vibe</p>
                <p className={`${greatVibes.className} wedding-gold-halo mt-3 text-4xl text-white`}>
                  Drinks, dancing,
                  <br />
                  and more memories
                </p>
              </div>
            </div>

            <div className="mt-8 rounded-[1.75rem] border border-[#decf9b] bg-white px-6 py-7 text-center shadow-sm">
              <p className="text-lg leading-9 text-[#686861] sm:text-xl">
                When the formal part of the day winds down, the celebration continues at
                <span className="mx-2 font-semibold text-[#1f3f6d]">
                  Tovil Working Mens Club
                </span>
                in Maidstone. If you took a screenshot of the details, this is the one to keep.
              </p>

              <a
                href="https://maps.google.com/?q=Tovil+Working+Mens+Club+Tovil+Hill+Maidstone+ME15+6QS"
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex min-h-14 items-center justify-center rounded-full bg-[#1f4e79] px-8 py-3 text-sm font-semibold uppercase tracking-[.14em] text-white transition hover:bg-[#173d61]"
              >
                Open in Maps
              </a>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
